import React from 'react';
import { HoopsStats } from './types';

const HoopsStatsComponent: React.FC<{ stats: HoopsStats[] }> = ({ stats }) => {
  return (
    <div className='card'>
      <div className='card-body'>
        <h5 className='card-title'>Hoops Statistics</h5>
        <div className='card-text'>
          <table className='table table-bordered'>
            <tbody>
              <tr>
                <th scope='row'>Arm</th>
                {stats.map(s => (
                  <td key={s.arm}>{s.arm}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Sessions</th>
                {stats.map(s => (
                  <td key={s.arm}>{s.sessions.toLocaleString()}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Average Score</th>
                {stats.map(s => (
                  <td key={s.arm}>{(s.averageScore || 0).toLocaleString()}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Max Score</th>
                {stats.map(s => (
                  <td key={s.arm}>{(s.maxScore || 0).toLocaleString()}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Shots</th>
                {stats.map(s => (
                  <td key={s.arm}>{s.shots.toLocaleString()}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Min Left Arm Angle</th>
                {stats.map(s => (
                  <td key={s.arm}>
                    {(s.avgMinLeftArmAngle || 0).toLocaleString()}
                  </td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Max Left Arm Angle</th>
                {stats.map(s => (
                  <td key={s.arm}>
                    {(s.avgMaxLeftArmAngle || 0).toLocaleString()}
                  </td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Min Right Arm Angle</th>
                {stats.map(s => (
                  <td key={s.arm}>
                    {(s.avgMinRightArmAngle || 0).toLocaleString()}
                  </td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Max Right Arm Angle</th>
                {stats.map(s => (
                  <td key={s.arm}>
                    {(s.avgMaxRightArmAngle || 0).toLocaleString()}
                  </td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Average Shot Duration</th>
                {stats.map(s => (
                  <td key={s.arm}>
                    {(s.avgShotDuration || 0).toLocaleString()}
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export { HoopsStatsComponent };
